import { render } from "./icon_monat.svg?vue&type=template&id=be655dca?inline"
const script = {}
script.render = render

export default script